export interface Bonus {
  title: string
  description: string
  price: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Poster Repertorio A3',
    description: 'Dodici poster illustrati da appendere in sala, con le sequenze e le regolazioni principali.',
    price: '25 €',
  },
  {
    title: 'Schede per le Allieve',
    description: 'Schede da consegnare a fine lezione, con esercizi, ripetizioni e note personali.',
    price: '25 €',
  },
  {
    title: 'Valutazione Iniziale',
    description: 'Questionario anamnestico, test di mobilità e scheda di valutazione posturale.',
    price: '20 €',
  },
  {
    title: 'Reformer Inclusivo',
    description: 'Adattamenti per gravidanza, post-parto, mal di schiena e articolazioni sensibili.',
    price: '15 €',
  },
  {
    title: '30 Sequenze Brevi',
    description: 'Flussi da 20 minuti per lezioni private, recuperi e classi a orario ridotto.',
    price: '15 €',
  },
]
